import { ICONS, IconType } from '@Const/common'
import React from 'react'
import './index.scss'

interface CircledIconProps {
    icon: IconType
    alt?: string
}
const CircledIcon = ({ icon, alt }: CircledIconProps) => (
    <div className="circled-icon">
        <img src={ICONS[icon]} alt={alt ?? icon} />
    </div>
)

export default CircledIcon
